import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonGroupComponent } from '@progress/kendo-angular-buttons';
import {
  EditorBackColorDirective,
  EditorBoldButtonDirective,
  EditorColorPickerComponent,
  EditorComponent,
  EditorFontFamilyComponent,
  EditorFontSizeComponent,
  EditorForeColorDirective,
  EditorInsertOrderedListButtonDirective,
  EditorInsertUnorderedListButtonDirective,
  EditorItalicButtonDirective,
  EditorStrikethroughButtonDirective,
  EditorUnderlineButtonDirective,
  EditorViewSourceButtonDirective,
} from '@progress/kendo-angular-editor';
import { CoreModule } from '../core/core.module';
import { AfterValueChangedDirective } from '../core/directives/after-value-changed.directive';
import { ClickOutsideDirective } from '../core/directives/click-outside.directive';
import { EditDocumentSectionDirective } from './invoice-theme/directives/edit-document-section.directive';
import { ShivePopupDirective } from '../core/directives/shive-popup.directive';
import { SortableRowsDirective } from '../core/directives/sortable-rows.directive';
import { SafeHtmlPipe } from '../core/pipes/safe-html.pipe';
import { SharedModule } from '../shared/shared.module';
import { AbsencePlannerComponent } from './absence-planner/absence-planner.component';
import { AbsencePlannerEventDialogComponent } from './absence-planner/dialogs/absence-planner-event-dialog/absence-planner-event-dialog.component';
import { AbsencePlannerEventsContainerDirective } from './absence-planner/directives/absence-planner-events-container.directive';
import { EventSlotDirective } from './absence-planner/directives/event-slot.directive';
import { OccupiedSlotPipe } from './absence-planner/pipes/occupied-slot.pipe';
import { AbsencePlannerEventInteractionDirective } from './absence-planner/planner-event/absence-planner-event-interaction.directive';
import { AbsencePlannerEventComponent } from './absence-planner/planner-event/absence-planner-event.component';
import { EventResizeHandleComponent } from './absence-planner/planner-event/parts/event-drag-handle/event-resize-handle.component';
import { CalendarModule } from './calendar/calendar.module';
import { InvoiceThemeShellComponent } from './invoice-theme/invoice-theme-shell/invoice-theme-shell.component';
import { MinimalInvoiceThemeComponent } from './invoice-theme/themes/minimal-invoice-theme/minimal-invoice-theme.component';
import { StandardInvoiceThemeComponent } from './invoice-theme/themes/standard-invoice-theme/standard-invoice-theme.component';
import { TodoContainerDirective } from './todo-planner/directives/todo-container.directive';
import { TodoEntryInteractionDirective } from './todo-planner/directives/todo-entry-interaction.directive';
import { TodoEntryWrapperDirective } from './todo-planner/directives/todo-entry-wrapper.directive';
import { TodoAssignToProjectComponent } from './todo-planner/popups/todo-assign-to-project/todo-assign-to-project.component';
import { TodoFileUploadPopupComponent } from './todo-planner/popups/todo-file-upload-popup/todo-file-upload-popup.component';
import { TodoEntryComponent } from './todo-planner/todo-entry/todo-entry.component';
import { TodoPlannerSidebarFormComponent } from './todo-planner/todo-planner-sidebar-form/todo-planner-sidebar-form.component';
import { TodoPlannerComponent } from './todo-planner/todo-planner.component';
import { TodoPlannerWeekViewComponent } from './todo-planner/views/todo-planner-week-view/todo-planner-week-view.component';

@NgModule({
  declarations: [
    AbsencePlannerComponent,
    EventResizeHandleComponent,
    AbsencePlannerEventComponent,
    AbsencePlannerEventDialogComponent,
    InvoiceThemeShellComponent,
    StandardInvoiceThemeComponent,
    MinimalInvoiceThemeComponent,
    TodoPlannerComponent,
    TodoPlannerWeekViewComponent,
    TodoEntryComponent,
    TodoPlannerSidebarFormComponent,
    TodoFileUploadPopupComponent,
    TodoAssignToProjectComponent,
  ],
  providers: [SafeHtmlPipe],
  imports: [
    CommonModule,
    RouterOutlet,
    CoreModule,
    SharedModule,
    ShivePopupDirective,
    EventSlotDirective,
    AbsencePlannerEventInteractionDirective,
    AbsencePlannerEventsContainerDirective,
    OccupiedSlotPipe,
    CalendarModule,
    EditDocumentSectionDirective,
    ButtonGroupComponent,
    SortableRowsDirective,
    SafeHtmlPipe,
    TodoEntryWrapperDirective,
    TodoContainerDirective,
    TodoEntryInteractionDirective,
    EditorBoldButtonDirective,
    EditorComponent,
    EditorFontFamilyComponent,
    EditorFontSizeComponent,
    EditorItalicButtonDirective,
    EditorUnderlineButtonDirective,
    EditorViewSourceButtonDirective,
    ClickOutsideDirective,
    AfterValueChangedDirective,
    EditorStrikethroughButtonDirective,
    EditorInsertUnorderedListButtonDirective,
    EditorInsertOrderedListButtonDirective,
    EditorColorPickerComponent,
    EditorForeColorDirective,
    EditorBackColorDirective,
  ],
  exports: [
    AbsencePlannerComponent,
    EventResizeHandleComponent,
    StandardInvoiceThemeComponent,
    InvoiceThemeShellComponent,
    CalendarModule,
    TodoPlannerComponent,
    TodoPlannerSidebarFormComponent,
  ],
})
export class FeaturesModule {}
